import { ReactNode, useEffect, useRef, useState } from 'react'
import * as S from './styles'
import { IUser } from '../../../user/contracts/iUser'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faChevronDown, faWrench } from '@fortawesome/free-solid-svg-icons';
import { PageTopMenuItem } from './types'

export { faWrench }
export type { PageTopMenuItem }

export interface PageTopProps {
  logo?: string
  user?: IUser
  logoAction?: () => void
  logoutAction?: () => void
  menuItems?: PageTopMenuItem[]
  children?: ReactNode
  backgroundColor?: string
  boxShadow?: string
  textColor?: string
  borderColor?: string
  textSizeWellcomeMessage?: string
  logoWidth?: string
  logoHeight?: string
}

const PageTop = ({
  logo,
  user,
  logoAction,
  logoutAction,
  menuItems,
  children,
  backgroundColor,
  boxShadow,
  textColor,
  textSizeWellcomeMessage,
  borderColor,
  logoWidth,
  logoHeight,
}: PageTopProps) => {

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false)
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
  }, [])

  const handleLogoClick = () => {
    if (logoAction) {
      logoAction()
    }
  }

  const handleClickLogout = () => {
    if (logoutAction) {
      logoutAction()
    }
  }

  const wellcomeMessage = `Bem vindo(a)${user?.name ? ', ' + user?.name : ''}!`

  return (
    <S.Wrapper $backgroundColor={backgroundColor} $boxShadow={boxShadow}>
      {logo ? (
        <S.LogoImgDiv
          href="#"
          onClick={handleLogoClick}
        >
          <S.LogoImg
            src={logo}
            alt="Logo"
            customLogoWidth={logoWidth}
            customLogoHeight={logoHeight}
          />
        </S.LogoImgDiv>
      ) : null}
      

      <S.WrapperRight>
        {children}

        <S.WrapperInfo>
          <S.Info 
            title={user?.name} 
            $textColor={textColor} 
            $textSizeWellcomeMessage={textSizeWellcomeMessage}>
            {wellcomeMessage}
          </S.Info>
          <S.Info title={user?.company?.name} $textColor={textColor} $textCompanyName>
            {user?.company?.name}
          </S.Info>
        </S.WrapperInfo>

        <S.UserImage
          src={user?.avatar}
          alt="avatar"
        />

        {menuItems && menuItems?.length > 0 && (
          <S.MenuWrapper ref={menuRef}>
            <S.ChevronButton
              $isOpen={isMenuOpen}
              $textColor={textColor}
              onClick={() => setIsMenuOpen(prev => !prev)}
            >
              <FontAwesomeIcon icon={faChevronDown} size="sm" />
            </S.ChevronButton>
            <S.DropdownMenu $isOpen={isMenuOpen}>
              {menuItems?.map((item, i) => (
                <S.DropdownItem
                  key={i}
                  as={item.path ? 'a' : 'button'}
                  href={item.path}
                  onClick={item.onClick}
                >
                  {item.icon && <FontAwesomeIcon icon={item.icon} size="sm" />}
                  {item.title}
                </S.DropdownItem>
              ))}
            </S.DropdownMenu>
          </S.MenuWrapper>
        )}

        <S.LogoutContent onClick={handleClickLogout} $textColor={textColor} $borderColor={borderColor}>
          <FontAwesomeIcon size="lg" icon={faArrowRightFromBracket} />
          <S.LogoutTooltip>Logoff</S.LogoutTooltip>
        </S.LogoutContent>
      </S.WrapperRight>
    </S.Wrapper>
  )
}

export default PageTop